// ----------------------------------------------------------------------
// <copyright file="Izenda.TenantItemAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var compose = require('recompose').compose;

  var withHandlers = require('recompose').withHandlers;
  var commonMessages = require('share/messages/Izenda.CommonMessages');
  const { curry, isNil } = require('lodash/fp');

  var tenantItemAction = compose(
    withHandlers({
      clickDelete: curry(clickDelete),
      clickVisible: curry(clickVisible),
      handleSelected: curry(handleSelected)
    })
  );

  /**
   * on click delete
   * @param  {object} props
   */
  function clickDelete(props, e) {
    e.stopPropagation();
    var store = props.store;
    var loader = props.loader;
    var valManager = props.validation;

    props
      .confirmFn('Confirmation', {
        description: store.getBundle().MESSAGE.DELETE
      })
      .then(function() {
        loader.startLoading();
        store
          .deleteTenant(props.tenantInfo.id)
          .then(function(result) {
            if (!isNil(result.messages)) {
              valManager.updateErrors(result.messages);
            }
          })
          .finally(loader.endLoading.bind(loader));
      });
  }

  /**
   * click visible
   * @param  {object} props
   */
  function clickVisible(props, e) {
    e.preventDefault();
    e.stopPropagation();
    var store = props.store;
    var tenantInfo = props.tenantInfo;
    var MESSAGE = store.getBundle().MESSAGE;
    var description = MESSAGE.DEACTIVATE;
    if (tenantInfo.active) {
      props
        .confirmFn('Confirmation', {
          description: description
        })
        .then(store.deactiveTenant.bind(store, tenantInfo));
    } else {
      store.activeTenant(tenantInfo);
    }
  }

  /**
   * handle selected tenant
   * @param  {object} props
   */
  function handleSelected(props, e) {
    var loader = props.loader;
    var store = props.store;
    loader.startLoading();

    props.store.setAlertMessage(commonMessages.EMPTY_MESSAGE.type, commonMessages.EMPTY_MESSAGE.message);
    props
      .confirmDirtyForm(store.showingTenantCloned.hasDirty)
      .then(function() {
        props.validation.reset();
        return props.store.loadTenant(props.tenantInfo);
      })
      .finally(loader.endLoading.bind(loader));
  }

  module.exports = tenantItemAction;
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/TenantManagement/Izenda.TenantItemAction.js